module.exports = __webpack_public_path__ + "static/media/tb_app_icon_editing.64031fb2.svg";